export default "__VITE_ASSET__CJCjfpLQ__"